export let BooleanHelper = {
  toggle(bool: boolean): boolean {
    return !bool
  },
  isStrictBoolean(anything: unknown): anything is boolean {
    return anything === true || anything === false
  },
  isStrictTrue(anything: unknown): anything is true {
    return this.isStrictBoolean(anything) && anything as true
  },
  isStrictFalse(anything: unknown): anything is false {
    return this.isStrictBoolean(anything) && !anything
  },
};
